import { Component, Input } from '@angular/core';
import { FormDetailsSectionBlockedData, FormDetailsSectionHeaderConfig, FormDetailsSectionHeaderIconType } from './form-details-section-header.model';

@Component({
    selector: 'ifbp-form-details-section-header',
    templateUrl: './form-details-section-header.component.html',
    styleUrls: ['./form-details-section-header.component.scss'],
    standalone: false
})
export class FormDetailsSectionHeaderComponent {
  @Input()
  config: FormDetailsSectionHeaderConfig;

  @Input()
  iconType: FormDetailsSectionHeaderIconType;

  @Input()
  sectionBlockedData?: FormDetailsSectionBlockedData;

  readonly IconType = FormDetailsSectionHeaderIconType;
}
